import type { BuilderDaSimulacao } from '../../types';
import { desfechoDesconhecido } from '../../utils/intencaoDeComando';
import { assinaturaVazia } from '../estadoInicial';
import { registroDaAssinaturaFinalizado } from '../eventosDoStore';
import { abrirAssinaturaSimulada, registrarResultadoDaAssinatura } from './actions';

export function registrarAssinaturasSimuladas(builder: BuilderDaSimulacao): void {
  builder
    .addCase(registroDaAssinaturaFinalizado, (state, action) => {
      // A tela pode ter mudado; só a intenção desta operação terminou.
      if (state.intencoes.registrarResultadoDaAssinatura?.requisicaoVigente === action.payload) {
        delete state.intencoes.registrarResultadoDaAssinatura;
      }
    })
    // Outra assinatura não herda nada da anterior; a mesma, relida, mantém o que já mostra.
    .addCase(abrirAssinaturaSimulada.pending, (state, action) => {
      if (state.assinatura.assinaturaId !== action.meta.arg) {
        state.assinatura = assinaturaVazia(action.meta.arg);
      }
      state.assinatura.carregando = true;
      state.assinatura.requisicaoDeLeitura = action.meta.requestId;
      state.assinatura.erro = null;
    })
    .addCase(abrirAssinaturaSimulada.fulfilled, (state, action) => {
      if (
        state.assinatura.assinaturaId !== action.meta.arg ||
        state.assinatura.requisicaoDeLeitura !== action.meta.requestId
      )
        return;
      state.assinatura.carregando = false;
      state.assinatura.simulacaoId = action.payload.simulacaoId;
      state.assinatura.dados = action.payload.assinatura;
    })
    .addCase(abrirAssinaturaSimulada.rejected, (state, action) => {
      if (
        state.assinatura.assinaturaId !== action.meta.arg ||
        state.assinatura.requisicaoDeLeitura !== action.meta.requestId
      )
        return;
      state.assinatura.carregando = false;
      state.assinatura.erro = action.payload ?? null;
    })
    .addCase(registrarResultadoDaAssinatura.pending, (state, action) => {
      state.assinatura.registrando = action.meta.arg;
      state.assinatura.requisicaoDeRegistro = action.meta.requestId;
      state.assinatura.erroDoRegistro = null;
      state.assinatura.resultadoComFalha = null;
    })
    .addCase(registrarResultadoDaAssinatura.fulfilled, (state, action) => {
      if (state.assinatura.requisicaoDeRegistro !== action.meta.requestId) return;
      state.assinatura.registrando = null;
      state.assinatura.requisicaoDeRegistro = null;
      if (state.assinatura.dados?.id === action.payload.id) {
        state.assinatura.dados = action.payload;
      }
      delete state.intencoes.registrarResultadoDaAssinatura;
    })
    // A chave só sobrevive ao desfecho desconhecido: é o retry dela que não republica (CA-19).
    .addCase(registrarResultadoDaAssinatura.rejected, (state, action) => {
      if (state.assinatura.requisicaoDeRegistro !== action.meta.requestId) return;
      state.assinatura.registrando = null;
      state.assinatura.requisicaoDeRegistro = null;
      state.assinatura.erroDoRegistro = action.payload ?? null;
      state.assinatura.resultadoComFalha = action.meta.arg;
      if (!desfechoDesconhecido(state.assinatura.erroDoRegistro)) {
        delete state.intencoes.registrarResultadoDaAssinatura;
      }
    });
}
